import { render, staticRenderFns } from "./worldhome.vue?vue&type=template&id=c34451d2&scoped=true&"
import script from "./worldhome.vue?vue&type=script&lang=js&"
export * from "./worldhome.vue?vue&type=script&lang=js&"
import style0 from "./worldhome.vue?vue&type=style&index=0&id=c34451d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34451d2",
  null
  
)

export default component.exports